import type { ReactNode } from 'react';
import { forwardRef } from 'react';
import ProgressBubble, { ProgressBubbleProps } from '../ProgressBubble';
import s from './StepperContentStage.scss';

interface Props {
  bubbleValue: ProgressBubbleProps['value'];

  /** Expects a single element. */
  content: ReactNode;

  /** Displayed directly below the content. */
  footnote?: ReactNode;
}

const StepperContentStage = forwardRef<HTMLDivElement, Props>(
  ({ bubbleValue, content, footnote }, ref) => {
    return (
      <div className={s['root']} ref={ref}>
        <ProgressBubble value={bubbleValue} />
        {content}
        {footnote && <div className={s['footnote']}>{footnote}</div>}
      </div>
    );
  }
);

StepperContentStage.displayName = 'StepperContentStage';

export default StepperContentStage;
